// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_btn__f-DoD {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  border-radius: var(--radius-control);
  font-family: var(--font-sans);
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  padding: 13px 20px;
  cursor: pointer;
  transition: background-color 0.18s ease, transform 0.05s ease, opacity 0.18s ease;
  -webkit-user-select: none;
          user-select: none;
}

.Button_btn__f-DoD:active {
  transform: translateY(1px);
}

.Button_btn__f-DoD:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.Button_full__WzclJ {
  width: 100%;
}

/* Variantes */
.Button_primary__MdNEd {
  background: var(--dylo-orange);
  color: #fff;
}
.Button_primary__MdNEd:hover:not(:disabled) {
  background: var(--dylo-orange-hover);
}
.Button_primary__MdNEd:active:not(:disabled) {
  background: var(--dylo-orange-active);
}

.Button_ghost__lMWGu {
  background: transparent;
  color: var(--dylo-ink);
  border: 1px solid var(--dylo-field-border);
}

/*
  🔴 **Aquí el texto desaparecía en tema oscuro.**

  El hover fijaba \`background: #f6f7f9\`, un gris casi blanco escrito a mano y sin token de tema.
  Funcionaba en claro por accidente —el texto es \`--dylo-ink\`, que ahí es oscuro— pero en oscuro
  \`--dylo-ink\` es casi blanco: quedaba blanco sobre blanco y el botón se veía **vacío** al pasar el
  cursor. Reportado en el bloque OUTPUT de Pre-alerta, y afectaba a **todos** los botones \`ghost\` de
  la plataforma, que son la mayoría de los secundarios.

  🔑 **Se deriva del propio color del texto con \`color-mix\`.** Así el contraste no depende de que
  alguien acierte dos valores por tema: en claro \`--dylo-ink\` es oscuro y el 8% da un gris tenue —el
  mismo aspecto que antes—; en oscuro es casi blanco y el 8% aclara apenas el fondo. El texto se lee
  en los dos casos porque el fondo **siempre** se construye a partir de él.
*/
.Button_ghost__lMWGu:hover:not(:disabled) {
  background: color-mix(in srgb, var(--dylo-ink) 8%, transparent);
  border-color: color-mix(in srgb, var(--dylo-teal-500) 45%, var(--dylo-field-border));
}

/* Spinner de carga */
/*
  ⚠️ Era blanco fijo (\`rgba(255,255,255,.5)\` + \`#fff\`), lo que sirve sobre el naranja del botón
  primario pero **desaparece en un botón \`ghost\` en tema claro**: blanco sobre blanco otra vez. Con
  \`currentColor\` hereda el color del texto del botón, así que en el primario sigue siendo blanco
  —mismo resultado que antes— y en el resto se ve.
*/
.Button_spinner__w5Fvf {
  width: 18px;
  height: 18px;
  border: 2px solid color-mix(in srgb, currentColor 35%, transparent);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: Button_btn-spin__bbKTd 0.7s linear infinite;
}

@keyframes Button_btn-spin__bbKTd {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/ui/Button/Button.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iFAAiF;EACjF,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA,cAAc;AACd;EACE,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;;;;;;;;;;;;;CAaC;AACD;EACE,+DAA+D;EAC/D,oFAAoF;AACtF;;AAEA,qBAAqB;AACrB;;;;;CAKC;AACD;EACE,WAAW;EACX,YAAY;EACZ,mEAAmE;EACnE,8BAA8B;EAC9B,kBAAkB;EAClB,sDAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: none;\n  border-radius: var(--radius-control);\n  font-family: var(--font-sans);\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1;\n  padding: 13px 20px;\n  cursor: pointer;\n  transition: background-color 0.18s ease, transform 0.05s ease, opacity 0.18s ease;\n  user-select: none;\n}\n\n.btn:active {\n  transform: translateY(1px);\n}\n\n.btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.full {\n  width: 100%;\n}\n\n/* Variantes */\n.primary {\n  background: var(--dylo-orange);\n  color: #fff;\n}\n.primary:hover:not(:disabled) {\n  background: var(--dylo-orange-hover);\n}\n.primary:active:not(:disabled) {\n  background: var(--dylo-orange-active);\n}\n\n.ghost {\n  background: transparent;\n  color: var(--dylo-ink);\n  border: 1px solid var(--dylo-field-border);\n}\n\n/*\n  🔴 **Aquí el texto desaparecía en tema oscuro.**\n\n  El hover fijaba `background: #f6f7f9`, un gris casi blanco escrito a mano y sin token de tema.\n  Funcionaba en claro por accidente —el texto es `--dylo-ink`, que ahí es oscuro— pero en oscuro\n  `--dylo-ink` es casi blanco: quedaba blanco sobre blanco y el botón se veía **vacío** al pasar el\n  cursor. Reportado en el bloque OUTPUT de Pre-alerta, y afectaba a **todos** los botones `ghost` de\n  la plataforma, que son la mayoría de los secundarios.\n\n  🔑 **Se deriva del propio color del texto con `color-mix`.** Así el contraste no depende de que\n  alguien acierte dos valores por tema: en claro `--dylo-ink` es oscuro y el 8% da un gris tenue —el\n  mismo aspecto que antes—; en oscuro es casi blanco y el 8% aclara apenas el fondo. El texto se lee\n  en los dos casos porque el fondo **siempre** se construye a partir de él.\n*/\n.ghost:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--dylo-ink) 8%, transparent);\n  border-color: color-mix(in srgb, var(--dylo-teal-500) 45%, var(--dylo-field-border));\n}\n\n/* Spinner de carga */\n/*\n  ⚠️ Era blanco fijo (`rgba(255,255,255,.5)` + `#fff`), lo que sirve sobre el naranja del botón\n  primario pero **desaparece en un botón `ghost` en tema claro**: blanco sobre blanco otra vez. Con\n  `currentColor` hereda el color del texto del botón, así que en el primario sigue siendo blanco\n  —mismo resultado que antes— y en el resto se ve.\n*/\n.spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid color-mix(in srgb, currentColor 35%, transparent);\n  border-top-color: currentColor;\n  border-radius: 50%;\n  animation: btn-spin 0.7s linear infinite;\n}\n\n@keyframes btn-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `Button_btn__f-DoD`,
	"full": `Button_full__WzclJ`,
	"primary": `Button_primary__MdNEd`,
	"ghost": `Button_ghost__lMWGu`,
	"spinner": `Button_spinner__w5Fvf`,
	"btn-spin": `Button_btn-spin__bbKTd`
};
export default ___CSS_LOADER_EXPORT___;
